import React from 'react'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { CoachingEventManagement } from './CoachingEventManagement'

/**
 * Main entry point for the Coaching Event management page
 * Provides Apollo client and date adapter context providers
 */
export const CoachingEventPage: React.FC = () => (
  <LocalizationProvider dateAdapter={AdapterDateFns}>
    <CoachingEventManagement />
  </LocalizationProvider>
)

export default CoachingEventPage
